import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { FlexCenter } from '../../global/commonStyle';

interface Props {
  isDisabled?: boolean;
  isActive?: boolean;
  inputType?: 'normal' | 'tags' | 'textarea';
  maxWidth?: string;
  height?: string;
  minHeight?: string;
  fieldWrapperWidth?: string;
  readOnly?: boolean;
  labelIconColor?: string;
  inputSize?: 'small' | 'large';
}

// icon design
export const Icon = styled.div<Props>`
  ${FlexCenter}
`;

export const LabelIcon = styled.div<Props>`
  width: 100%;
  height: 8px;
  border-radius: var(--border-radius-full);
  max-width: 8px;
  background-color: ${({ labelIconColor }) => labelIconColor};
`;

// field wrapper
export const FieldWrapper = styled.div<Props>`
  width: ${({ fieldWrapperWidth }) => fieldWrapperWidth};
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

export const Label = styled.label<Props>`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      color: var(--text-muted);
    `}
`;

export const InputWrapper = styled.div<Props>`
  position: relative;
  max-width: ${({ maxWidth }) => maxWidth};
  min-height: ${({ minHeight }) => minHeight};
  padding: ${({ inputType }) =>
    inputType === 'tags'
      ? 'var(--space-5) var(--space-8) var(--space-5) var(--space-5)'
      : inputType === 'textarea'
      ? 'var(--space-0)'
      : 'var(--space-8) var(--space-8) var(--space-8) var(--space-12)'};
  background-color: var(--background-primary);
  box-shadow: ${({ isActive }) => (isActive ? 'var(--border-active)' : 'var(--border)')};
  border-radius: var(--border-radius-8);
  display: flex;
  align-items: ${({ minHeight }) => (minHeight ? 'flex-start' : 'center')};
  gap: var(--space-10);
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  overflow: ${({ inputType }) => (inputType === 'textarea' ? 'hidden' : 'unset')};
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      background-color: var(--background-primary);
      pointer-events: none;
    `}
  &:hover {
    box-shadow: ${({ isActive, isDisabled, readOnly }) =>
      isDisabled || readOnly ? 'var(--border)' : isActive ? 'var(--border-active)' : 'var(--border-hover)'};
    cursor: ${({ readOnly }) => (readOnly ? 'default' : 'pointer')};
  }
  [type='number'] {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: var(--space-0);
    }
  }
  ${(props) =>
    props.inputSize === 'small' &&
    css`
      padding: var(--space-3) var(--space-10);
      border-radius: var(--border-radius-4);
      background: var(--background-tertiary);
      ${Typography.body_md}
    `}
  /* dropdown icon css */
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

// Input field
export const InputField = styled.input<Props>`
  width: 100%;
  border: unset;
  padding: var(--space-0);
  background: transparent;
  ${Typography.body_lg};
  color: var(--text-primary);
  background-color: var(--background-primary);
  &:disabled {
    color: var(--text-muted);
    &::placeholder {
      color: var(--text-muted);
    }
  }
  ${(props) =>
    props.inputSize === 'small' &&
    css`
      background: var(--background-tertiary);
      ${Typography.body_md}
    `}
  :read-only {
    cursor: default;
  }
  ::placeholder {
    color: var(--text-placeholder);
  }
  &:focus-visible {
    outline: unset;
  }
`;
